import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", testId }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const ChapterTag = ({ index, label }) => (
  <div className="flex items-center gap-3 font-mono text-xs tracking-[0.3em] uppercase">
    <span className="text-gold">{String(index).padStart(2, "0")}</span>
    <span className="h-px w-10 bg-teal/60" aria-hidden="true" />
    <span className="text-teal">{label}</span>
  </div>
);

export const SectionHeader = ({ index, eyebrow, title, sub, align = "left", testId }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} testId={testId}>
    <div className={align === "center" ? "flex justify-center" : ""}>
      <ChapterTag index={index} label={eyebrow} />
    </div>
    <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-mist">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base md:text-lg text-slate leading-relaxed">{sub}</p>}
  </Reveal>
);

export const StatusChip = ({ children, tone = "slate", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] tracking-[0.2em] uppercase ${
      tone === "gold"
        ? "border-gold/40 text-gold bg-gold/5"
        : tone === "teal"
        ? "border-teal/40 text-teal bg-teal/5"
        : "border-line text-slate bg-navy/40"
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${tone === "gold" ? "bg-gold" : tone === "teal" ? "bg-teal" : "bg-slate"}`} aria-hidden="true" />
    {children}
  </span>
);

export const LogoMark = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true" className="shrink-0">
      <path d="M32 10l19 11v22L32 54 13 43V21z" fill="none" stroke="#18B7A0" strokeWidth="3" />
      <circle cx="32" cy="32" r="6.5" fill="#D6B56A" />
      <circle cx="32" cy="10" r="2.5" fill="#18B7A0" className="animate-node-pulse" />
      <circle cx="51" cy="43" r="2.5" fill="#18B7A0" className="animate-node-pulse" style={{ animationDelay: "1s" }} />
      <circle cx="13" cy="43" r="2.5" fill="#18B7A0" className="animate-node-pulse" style={{ animationDelay: "2s" }} />
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className="block font-display font-bold tracking-[0.18em] text-mist text-sm sm:text-base">JOVINO COIN</span>
        <span className="block font-mono text-[10px] tracking-[0.3em] text-teal mt-1">JCV • BEP-20</span>
      </span>
    )}
  </span>
);
